<template>
  <div id="app">
      <my-header></my-header>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <!-- <tell-us v-if="this.$route.meta.tellUsShow"></tell-us>
    <my-footer v-if="this.$route.meta.footerShow"></my-footer> -->
    <tell-us></tell-us>
    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyHeader from './components/MyHeader';
  import MyFooter from "./components/MyFooter";
  import TellUs from "./components/TellUs";

  export default {
    name: 'App',
    components: {MyFooter, MyHeader,TellUs},
    mounted() {
      this.path = this.$route.path;
    },
    watch:{
      $route(to,from){
        this.path = to.path
      }
    },
    data(){
      return{
        currentMenuIndex0:0,
      navList: this.$router.options.routes.filter((route)=>{
        return !route.redirect
      })
    }
    },
    methods:{

    }

  }
</script>

<style>
  @import './styles/common.css';
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity:.8;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue